// extracted by mini-css-extract-plugin
export default {"latency_graph":"ServerLatencyGraph_latency_graph__Q5Ao8","average_ping":"ServerLatencyGraph_average_ping__w3IZY"};